import { Button, notification } from 'antd'
import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { API } from 'src/utils/interceptor'

const shownVenues = new Set()

const alertKey = venueId => `recipe-gp-dashboard-alert-${venueId}`

/**
 * One sign-in note. A monitored GP change wins. Otherwise a quiet upgrade
 * note, only for someone who can open plans, when stored recipes missed a price change.
 */
const useRecipeGpDashboardAlert = (venueId, enabled, canUpgrade = false) => {
  const history = useHistory()

  useEffect(() => {
    if (!venueId || !enabled) return undefined
    if (shownVenues.has(venueId)) return undefined
    shownVenues.add(venueId)

    const run = async () => {
      try {
        const alert = await API.get(
          'api2',
          `recipes/venue/${venueId}/gp-review-alert`,
        )
        if (!alert?.show || !alert?.body) return
        const isUpsell = alert.kind === 'monitor-upsell'
        if (isUpsell && !canUpgrade) return
        const key = alertKey(venueId)
        notification.open({
          key,
          message: alert.title || 'Recipe costs updated',
          description: alert.body,
          duration: 0,
          btn: (
            <Button
              size='small'
              onClick={() => {
                notification.close(key)
                history.push(
                  isUpsell
                    ? `/v/${venueId}/subscriptions/oms-plans`
                    : `/v/${venueId}/menu-builder?gpChanged=1`,
                )
              }}
            >
              {alert.actionLabel || (isUpsell ? 'See plans' : 'Review recipes')}
            </Button>
          ),
        })
        await API.post(
          'api2',
          `recipes/venue/${venueId}/gp-review-alert/seen`,
          {
            body: isUpsell
              ? { kind: 'monitor-upsell' }
              : { changes: alert.changes || [] },
          },
        )
      } catch (error) {
        shownVenues.delete(venueId)
        return error
      }
    }

    run()
    return undefined
  }, [venueId, enabled, canUpgrade, history])
}

export default useRecipeGpDashboardAlert
